import { useState } from 'react';
import { Box, Typography, Container, Button, styled } from '@mui/material';
import { Helmet } from 'react-helmet-async';

import RefreshTwoToneIcon from '@mui/icons-material/RefreshTwoTone';

const MainContent = styled(Box)(
  () => `
    height: 100%;
    display: flex;
    flex: 1;
    overflow: auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`
);

function Status500() {
  const [pending, setPending] = useState(false);
  function handleClick() {
    setPending(true);
  }

  return (
    <>
      <Helmet>
        <title>Status - 500</title>
      </Helmet>
      <MainContent>
        <Container maxWidth="sm">
          <Box textAlign="center">
            <img alt="500" height={260} src="/static/images/status/500.svg" />
            <Typography variant="h2" sx={{ my: 2 }}>
              There was an error, please try again later
            </Typography>
            <Typography
              variant="h4"
              color="text.secondary"
              fontWeight="normal"
              sx={{ mb: 4 }}
            >
              The server encountered an internal error and was not able to
              complete your request
            </Typography>
            <Button
              onClick={handleClick}
              loading={pending}
              variant="outlined"
              color="primary"
              startIcon={<RefreshTwoToneIcon />}
            >
              Refresh view
            </Button>
            <Button href="/" variant="contained" sx={{ ml: 1 }}>
              Go back
            </Button>
          </Box>
        </Container>
      </MainContent>
    </>
  );
}

export default Status500;
